











































































































































































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ToolMixin from '@/mixins/Tool.vue';
import utils from '@/services/utils';
import GeneralModule from '@/store/modules/General';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {},
})
export default class NewMemberBody extends Mixins(ErrorHandleMixin, ToolMixin) {
  GeneralInstance = getModule(GeneralModule, this.$store);

  @Prop() readonly data: any;

  @Prop() readonly summary: any;

  @Prop() readonly fetchWinloseAgentElastic!: Function;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly mainRole!: string;

  @Prop() readonly isMultiCurrency!: boolean;

  utilsInstance = utils;

  handleSubElastic(items) {
    this.fetchWinloseAgentElastic(items);
  }
}
